<template>
  <div class="welcome sides-padding">
    <div class="container">
      <div class="welcome-inner">
        <h1 class="welcome-title">Добро пожаловать на Baby Market!</h1>
        <span class="welcome-subtitle">
          Baby Market – это концептуальный и сказочный мир для детей и будущих родителей.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WelcomeComponent",
};
</script>

<style lang="stylus">
.welcome {
  height 500px
  padding-top 95px
  padding-bottom 45px
  margin-bottom -250px
  background linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, var(--white) 100%), url(/static/images/welcome.png)
  background-repeat no-repeat
  background-size: 100% 250px, cover
  background-position bottom, top
  color var(--main-color)
  +below(840px) {
    height 320px
    margin-bottom -30px
    background-size: 100% 130px, cover
    padding-top 72px
  }
  +below(480px) {
    height auto
    padding 30px
  }

  &-inner {
    padding-left 10px
    +below(840px) {
      max-width 452px
      padding-left 0
    }
    +below(480px) {
      max-width 280px
    }
  }

  &-title {
    font-size: 2.125em
    line-height: 120%
    text-transform none
    text-align left
    +below(480px) {
      font-size: 1.375em
    }
  }

  &-subtitle {
    display flex
    max-width 630px
    +below(480px) {
      font-size 0.875em
    }
  }
}
</style>
